<template>
  <div class="sunshine-port">
    <Crumbs :info='info' :title='navList[0]'/>
    <div class="port-container">
      <div class="port-nav">
        <menu-com :navList='navList'></menu-com>
      </div>
      <div class="port-content">
        <h2>前期资质办理</h2>
        <p>根据客户确认的合规化解决方案，为客户办理电商企业前期资质。共9项办理事项，客户根据平台指导准备资料，由平台专属服务人员代为办理。</p>
        <img src="../../../assets/images/other/ohter.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import menuCom from "./common/menuCom.vue"
import Crumbs from "./common/Crumbs.vue"
import {navList} from "../../../model/enter"

export default {
  components:{
    menuCom,Crumbs
  },
  data () {
    return {
      info:{},
      navList,
    }
  },
  created(){
    const path=this.$route.fullPath;
    const index=navList.findIndex(item=>item.path===path);
    if(index!==-1){
      this.info=navList[index];
    }
  }
};
</script>

<style scoped>
.port-container {
  width: 1200px;
  height: 920px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex:1;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Enter/Customize.vue